<template>
    <div class="image-select">
        <v-container fluid grid-list-sm pa-0 py-2>
            <v-layout row wrap>
                <v-flex xs4 v-for="item in items" :key="item.value" class="text-xs-center image-selector">
                    <v-img
                        :src="item.text"
                        contain
                        class="image"
                        :class="{
                            selected: isSelected(item.value),
                        }"
                        @click="onImageClick(item.value)"
                    />
                    <p @click="onImageClick(item.value)" class="caption ma-0 label">{{item.name}}</p>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<style lang="scss" scoped>
.image-select {
    word-break: break-word;

    .image {
        border: 4px solid transparent;
    }

    .image-selector {
        cursor: pointer;
    }

    .selected,
    .image-selector:hover .image {
        border: 4px solid #414141;
    }

    .label {
        margin-top: 2px !important;
        line-height: 1;
    }
}
</style>

<script>
export default {
    name: 'ImageSelector',
    props: {
        label: String,
        icon: {
            type: String | null,
            default: null,
        },
        value: {
            type: Array,
            default: [],
        },
        items: {
            type: Array,
            default: [],
        },
        readonly: Boolean,
    },
    methods: {
        isSelected(value) {
            return this.value.includes(value);
        },
        onImageClick(attributeValue) {
            if (!this.readonly) {
                let newValue = null;
                if (this.value.includes(attributeValue)) {
                    newValue = this.value.filter(el => el !== attributeValue);
                } else {
                    newValue = this.value.concat([attributeValue]);
                }
                this.$emit('change', {
                    attributeValue,
                    value: newValue.indexOf(attributeValue) !== -1,
                });
            }
        },
    },
};
</script>
